export default __webpack_public_path__ + "static/media/Prakhar.1e2fb54c.jpg";